import { ErrorResponse } from '@models/error.response';
import { TranslateService } from '@ngx-translate/core';
import { MainComponent } from '../main/main.component';
import { of, from } from 'rxjs';
import { ActionType } from '@type/action.type';
import { AppConstant } from '@constants/app.constant';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import swal from 'sweetalert2';
import { switchMap, map, flatMap, filter, toArray, mergeMap, reduce } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { AdminUserService } from '@app/services/admin-user-service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectUtil } from '@app/utils/ng-select-utils';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { CommonService } from '@app/services/common.service';
import { HtmlTemplate } from '@app/models/html-template';
import { HtmlTemplateService } from '@app/services/html-template.service';
import { ApplicationFile } from '@app/models/application-file';
import { BinaryFileService } from '@app/services/binary-file.service';
import { BinaryFile } from '@app/models/binary-file';
import { UploadOutput } from 'ngx-uploader';

declare var toastr: any;
const MAX_DOCUMENT_FILE_SIZE: number = 4 * 1024 * 1024;

@Component({
    templateUrl: './html-template-setup.component.html',
    styleUrls: ['./html-template-setup.component.scss']
})
export class HtmlTemplateSetupComponent {
    @ViewChildren(NgSelectComponent) ngSelects: QueryList<NgSelectComponent>;
    selectAll = NgSelectUtil.selectAll
    @ViewChild('workflowForm', { static: false }) workflowForm: NgForm;
    @ViewChild('documentFileSelect', { static: false }) documentFileSelect: ElementRef;
    isFieldError = FormValidationUtil.isFieldError;
    action: ActionType;
    loading: boolean = false;
    clickSave: boolean = false;
    isShowAdd:boolean = false;
    isShowUpdate:boolean = false;
    validUser: boolean = true;


    binaryFileApplication: ApplicationFile;

    htmlTemplateFileOptions: string[]=['designA.png'];
    templateFieldLocationOptions: string[]=['default'];
    record: HtmlTemplate;
    selectedTemplateFile: any;
    maxFieldSeq = 1;
    imgFile: BinaryFile;


    constructor(
        private adminUserService: AdminUserService,
        private workFlowFormService: HtmlTemplateService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private commonService: CommonService,
        private translate: TranslateService,
        public appConstant: AppConstant,
        protected binaryFileService: BinaryFileService) {
    }

    ngOnInit(): void {
        this.record = new HtmlTemplate();
        let companyCode =  this.commonService.getCurrentUser().companyCode;
        
       

        // this.taskTypeOptions = [].concat(this.commonTaskTypeOptions)
        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.loading = true;
                    if (params['id'] === 'new') {
                        this.action = 'CREATE';
                        this.isShowAdd = this.commonService.showAddButton(this.action,'PERM_ONEPAGE_TEMPLATE_CREATE');
                    } else {
                        this.action = 'EDIT';
                        this.isShowUpdate = this.commonService.showUpdateButton(this.action,'PERM_ONEPAGE_TEMPLATE_UPDATE');
                    }
                    return of(params);
                }),
                switchMap((params: Params) => {
                    return this.adminUserService.findAll()
                        .pipe(
                            map(users => {
                            //    this.userOptions = users;
                                return params;
                            })
                        );
                }),
                switchMap((params: Params) => {
                    if (this.action == 'CREATE') {
                        let form = new HtmlTemplate();
                        return of(form);
                    } else {
                        return this.workFlowFormService.get(params['id'])
                    }
                })
            )
            .subscribe((workflowForm: HtmlTemplate) => {
                this.record = workflowForm;
                this.imgFile = this.record.htmlTemplateImage;
                // alert(this.record.status);
                  
                this.loading = false;
            });

    }

   
    changeSelectedTemplateFile(filename) {
        this.selectedTemplateFile = filename;
        // this.record.templateFileName = filename;
        this.templateFieldLocationOptions = ['A','B'];

        // if (type == 'COMPANY') {
        //  //   this.taskTypeOptions = [].concat(this.commonTaskTypeOptions).concat(this.companyTaskTypeOptions);
        //     // this.record.type = type;
        // } else {
        //     // this.taskTypeOptions = [].concat(this.commonTaskTypeOptions);
        //     // let index = this.taskTypeOptions.indexOf('COMPANY_REGISTER_GEN');
        //     // let invoicingIndex = this.taskTypeOptions.indexOf('INVOICING');
        //     // if (index > 0 || invoicingIndex > 0) {

        //         // let existCompanyTask = this.record.formTasks.find(formTask => this.companyTaskTypeOptions.indexOf(formTask.taskType) != -1);
        //         // if (!this.isEmptyTask()) {
        //         //     if (existCompanyTask) {
        //         //         this.translate.get(['CONFIRM_TO_CHANGE_TASK_TYPE',
        //         //             'CONFIRM',
        //         //             'CANCEL'])
        //         //             .subscribe(res => {
        //         //                 swal.fire({
        //         //                     text: res.CONFIRM_TO_CHANGE_TASK_TYPE,
        //         //                     type: 'warning',
        //         //                     showCancelButton: true,
        //         //                     allowOutsideClick: false,
        //         //                     cancelButtonText: res.CANCEL,
        //         //                     confirmButtonText: res.CONFIRM
        //         //                 }).then(result => {
        //         //                     if (result.value) {
        //         //                         // handle confirm
        //         //                         let removeFormTasks: WorkflowFormTask[] = [];
        //         //                         this.record.formTasks.forEach(formTask => {
        //         //                             if (this.companyTaskTypeOptions.indexOf(formTask.taskType) != -1) {
        //         //                                 removeFormTasks.push(formTask);
        //         //                             }
        //         //                         })
        //         //                         if (removeFormTasks.length > 0) {
        //         //                             removeFormTasks.forEach(removeFormTask => {
        //         //                                 this.record.formTasks = this.record.formTasks.filter(item => item.taskType != removeFormTask.taskType);
        //         //                             })
        //         //                         }
        //         //                         this.taskTypeOptions = [].concat(this.commonTaskTypeOptions);
        //         //                         // this.record.type = type;
        //         //                     } else {
        //         //                         // handle dismiss, result.dismiss can be 'cancel', 'overlay', 'close', and 'timer'
        //         //                     }
        //         //                 });
        //         //             });
        //         //     } else {
        //         //         this.taskTypeOptions = [].concat(this.commonTaskTypeOptions);
        //         //         // this.record.type = type;
        //         //     }
        //         // }

        //     // }
        // }



    }
  


    save(): void {

        this.clickSave = true;
        //check form for just clicking save without any input
        for (let key of Object.keys(this.workflowForm.controls)) {
            this.workflowForm.controls[key].markAsDirty();
        }


        // this.initFormTask();

        if (!this.validUser) {
            alert(111);
            return;
        }

        // var px = this.record.templateFileName.indexOf(".");
        // this.record.templateFileCode = this.record.templateFileName.substring(0, px);

        if (this.workflowForm.valid) {
            
            this.record.htmlTemplateImage = this.imgFile;

            switch (this.action) {
                case 'CREATE':
                    this.create();
                    break
                case 'EDIT':
                    this.update();
                    break;
            }
        }
    }
  

    private create(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.workFlowFormService.insert(this.record)
            .subscribe(() => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.HTML_TEMPLATE_PATH]);

                this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_ADDED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });
            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;
                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_ADD, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });

                        });
                });
    }

    private update(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.workFlowFormService.update(this.record)
            .subscribe(record => {
                this.record = record;
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.HTML_TEMPLATE_PATH]);

                this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;


                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                })

    }

    cancel(): void {
        this.router.navigate([ModulePathConstant.HTML_TEMPLATE_PATH]);
    }

    fileLoading: boolean = false;
      
    downloadFile() {
        let item = this.imgFile;
        this.fileLoading = true;
        item._selected = true;
        this.binaryFileService.downloadFile(item.binaryFileId)
            .subscribe(blob => {

                FileSaver.saveAs(blob, item.fileName);
                this.fileLoading = false;
                item._selected = false;
            }, (error: ErrorResponse) => {
                this.fileLoading = false;
                item._selected = false;
                from(error.errors)
                    .pipe(
                        mergeMap(error => this.translate.get(error.errorCode)),
                        reduce((acc, value) => acc + value + '<br/>', '')
                    )
                    .subscribe(msg => {
                        this.translate.get(item.fileName)
                            .pipe(
                                switchMap(typeStr => this.translate.get('FAIL_TO_DOWNLOAD', { type: typeStr }))
                            )
                            .subscribe(title => {
                                toastr.options = {
                                    "closeButton": true,
                                    "positionClass": "toast-bottom-right",
                                    "timeOut": "0",
                                    "extendedTimeOut": "0"
                                }
                                toastr.error(msg, title);
                            });
                    });
            })
    }

    showDownloadButton() {
        if (!this.imgFile) {
            return false;
        }
        return this.imgFile.binaryFileId != null && !(this.imgFile._selected)
    }

    removeDocuments(): void {
        if (!this.imgFile || this.imgFile.fileName == null) {
            return;
        }
        this.imgFile._selected = true;
        this.imgFile = null;
        this.documentFileSelect.nativeElement.value = '';
    }
    
    public onAttachmentUploadOutput(output: UploadOutput): void {
        if (output.file != null) {
            this.binaryFileApplication = null;
            if (this.imgFile == null) {
                this.imgFile = new BinaryFile();
            }
            this.binaryFileApplication = new ApplicationFile(output.file, null, MAX_DOCUMENT_FILE_SIZE);
            this.binaryFileApplication.readAsBase64((result) => {
                this.imgFile.content = result;
                this.imgFile.fileName = output.file.name;
                this.imgFile.fileSize = output.file.size;
                this.imgFile._fileName = output.file.name;
                this.imgFile._selected = true;
                this.documentFileSelect.nativeElement.value = '';
            })
        }
    }
 
}
